import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useSurveyParams } from '../context/SurveyParamsContext'
import { useProgressSaving } from '../hooks/useProgressSaving'
import {
  convertVisibleIf,
  convertTriggers,
  convertQuestionMappings,
  convertNotRequired,
  q,
  v,
} from '../utils/convertVisibleIf'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const { userId, sfdSamplerId, sfdPId } = useSurveyParams()
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const userIdRef = useRef(null)
  useEffect(() => {
    if (userId) userIdRef.current = userId
  }, [userId])
  // 需要登入嗎
  const requiresLogin = {
    login: userId ? true : false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
    // useUserIdLogin: true,
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = convertVisibleIf({
    // 用1開始計算填這裡，工具自動轉成0開始

    q20: '{q19} = 2 or {q19} = 3 or {q19} = 4 or {q19} = 5 or {q19} = 6 or {q19} = 7',
    q22: '{q21} anyof [1, 2, 3, 4, "other"]',

    q25: '{q24} = 2',
    q26: '{q24} = 3',
    q27: '{q24} = 4',
    q28: '{q24} = 2',
    q29: '{q28} = 2',
    //
    q30: '{q24} = 3',
    q31: '{q24} = 4',
    q32: '{q24} = 2',

    q33: '{q24} = 3',
    q34: '{q24} = 4',
    q35: '{q24} = 2',

    q36: '{q24} = 3',
    q37: '{q24} = 4',
  })
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 1 計算，工具自動轉成 0 開始)
  // const notRequired = convertNotRequired([118.5])
  const notRequired = convertNotRequired([1, 4, 9, 17, 23, 38, 44])

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = convertTriggers([
    {
      type: 'complete',
      expression: `({q2} = 2) or ({q3} = 2) or ({q7} = 3) or ({q8} anyof [1, 2, 3]) or ({q6} = 1) or ({q6} = 2) or ({q6} = 8) or ({q10} anyof ["none"]) or ({q11} = 3) or ({q13} = 1) or ({q18} anyof ["none"])`,
    },
  ])
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入 (用1開始計算填這裡)
  const questionMappings = convertQuestionMappings({
    // q37: 'q38',
  })

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    userIdRef,
    choiceIndexMapRef,
    sfdSamplerId,
    sfdPId,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  useProgressSaving({
    userIdRef,
    surveyModel,
    convertedSurvey: myAgreeJson,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    sfdSamplerId,
  })

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage1 = `謝謝您，該條件配額已額滿。期待未來有機會再邀請您參與！<br><br>如有任何問題，請於週一到週五上班日10:00~18:00電話聯繫臺北表演藝術中心或典通，我們會盡快回覆您的問題。<br><br>北藝專案窗口│02-77563800＃1335<br>典通市調專線│02-23315133＃827`

  const endMessage2 = `謝謝您，期待未來有機會再邀請您參與！<br><br>如有任何問題，請於週一到週五上班日10:00~18:00電話聯繫臺北表演藝術中心或典通，我們會盡快回覆您的問題。<br><br>北藝專案窗口│02-77563800＃1335<br>典通市調專線│02-23315133＃827`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q7)', survey.getValue('q7'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    // A8
    if (
      survey.getValue(q(6)) === v(1) ||
      survey.getValue(q(6)) === v(2) ||
      survey.getValue(q(6)) === v(8) ||
      survey.getValue(q(10))?.[0] === 'none' ||
      survey.getValue(q(11)) === v(3) ||
      survey.getValue(q(13)) === v(1) ||
      survey.getValue(q(18))?.[0] === 'none'
    ) {
      setCompletionMessage(endMessage1)
    }
    // A9
    else if (
      survey.getValue(q(2)) === v(2) ||
      survey.getValue(q(3)) === v(2) ||
      survey.getValue(q(7)) === v(3) ||
      survey.getValue(q(8))?.includes(0) ||
      survey.getValue(q(8))?.includes(1) ||
      survey.getValue(q(8))?.includes(2)
    ) {
      setCompletionMessage(endMessage2)
    } else {
      setCompletionMessage(
        `感謝您與我們分享想法！<br><br>如有任何問題，請於週一到週五上班日10:00~18:00電話聯繫臺北表演藝術中心或典通，我們會盡快回覆您的問題。<br><br>北藝專案窗口│02-77563800＃1335<br>典通市調專線│02-23315133＃827`
      )
    }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    requiresLogin,
    userIdRef,
    enableProgressSaving: requiresLogin.login || !!sfdSamplerId,
    sfdSamplerId,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
